export function buildChartTooltip({ header, subheader, metrics = [] }) {
    if (!header) return '';

    const metricRows = metrics
        .filter((metric) => metric && metric.label)
        .map(
            (metric) =>
                `<div class="tooltip-metric">${metric.label}: <strong>${metric.value}</strong></div>`
        )
        .join('');

    return `
        <div class="chart-tooltip">
            <div class="tooltip-header"><strong>${header}</strong></div>
            <div class="tooltip-body">
                ${subheader ? `<div>${subheader}</div>` : ''}
                ${metricRows}
            </div>
        </div>
    `;
}
